export const onWindowLoad = (fn: () => void) => {
  if (typeof document === 'undefined') { return; }

  const callFn = () => setTimeout(() => fn(), 800);

  if (document.readyState === 'complete') {
    callFn();
  } else {
    window.addEventListener('load', callFn);
  }
};
